import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatCOP(cents: number): string {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function formatDeltaPct(delta: number | null): { text: string; tone: 'up' | 'down' | 'flat' } {
  if (delta === null) return { text: '—', tone: 'flat' };
  const sign = delta > 0 ? '+' : '';
  return {
    text: `${sign}${delta.toFixed(1)}%`,
    tone: delta > 0 ? 'up' : delta < 0 ? 'down' : 'flat',
  };
}

export function initials(first: string, last: string): string {
  return `${first[0] ?? ''}${last[0] ?? ''}`.toUpperCase();
}

/**
 * El enlace del portal, armado con el dominio que el navegador está usando.
 *
 * Estaba escrito en duro como `https://app.groomingpro.app`, un dominio que
 * **no existe**: no resuelve en DNS, así que cada clienta que recibía el
 * mensaje por WhatsApp se topaba con un error del navegador. Lo reportó el
 * salón el 1/10/2026, y no lo detecta ni el typecheck ni el build — una URL
 * es una cadena de texto y nadie la comprueba.
 *
 * Se arma desde `window.location.origin` por la misma razón que la dirección
 * de Supabase en `src/lib/supabase.ts`: el sistema se sirve desde más de un
 * dominio y el código no puede saber cuál tiene delante el salón.
 */
export function enlaceDelPortal(): string {
  return `${window.location.origin}/portal/login`;
}
